import React from 'react'

function Aboutteem() {
  return (
    <>
        <section className="team-two">
            <div className="container">
                <div className="row gutter-y-60">
                <div className="col-md-12 col-lg-6">
                    <div className="team-two__image">
                    <img src="assets/images/team/team-2-1.jpg" className="img-fluid"/>
                    </div>
                   
                </div>
              
                <div className="col-md-12 col-lg-6 d-flex">
                    <div className="my-auto">
                    <div className="team-two__content">
                        <div className="sec-title text-start">
                        <p className="sec-title__tagline">about me</p>
                        
                        <h3 className="sec-title__title">Hello, I’m Robert A. Haskins</h3>
                       
                        </div>
                        
                        <div className="team-two__text">
                        We denounce with righteous indignation and dislike men beguiled
                        demoraliz the charms of pleasure the moment desire they cannotes
                        foresee the pain and trouble that are bound ensuequal blame
                        </div>
                       
                        <div className="team-two__text">
                        Quis autem vel eum iure reprehenderit in ea voluptate velit esse
                        quam nihiley molestiae consequatur vel illum qui dolorem eum
                        fugiat
                        </div>
                       
                        <ul className="list-unstyled contact-one__info">
                        <li className="contact-one__info__item">
                            <div className="contact-one__info__icon">
                            <i className="far fa-envelope-open" />
                            </div>
                            
                            <div className="contact-one__info__content">
                            <span className="contact-one__info__name">Email Address</span>
                            <a href="mailto:service1@finrelinsure.com"></a>
                            </div>
                            
                        </li>
                        <li className="contact-one__info__item">
                            <div className="contact-one__info__icon">
                            <i className="far fa-phone-plus" />
                            </div>
                            
                            <div className="contact-one__info__content">
                            <span className="contact-one__info__name">Phone No</span>
                            <a href="tel:+000(123)45688">+000 (123) 456 88</a>
                            </div>
                            
                        </li>
                        </ul>
                        
                    </div>
                    
                    </div>
                   
                </div>
              
                </div>
               
            </div>
           
        </section>

    </>
  )
}

export default Aboutteem